import cn from 'classnames'
import mixpanel from 'mixpanel-browser'
import Link from 'next/link'
import React from 'react'
import { MIXPANEL_ENABLED, THEME } from 'src/config/config'
import { IEnum_Solution_Type } from 'src/graphql/generated/hooks'

import styles from './CallToActionButton.module.css'

interface CallToActionProps {
  displayName: string
  solutionId: string
  solutionType: IEnum_Solution_Type
  label?: string | null
  url: string
}

/**
 * Primary UI component for user interaction
 */
export const CallToActionButton: React.FC<CallToActionProps> = ({
  displayName,
  label = 'Request a demo',
  url,
  solutionId,
  solutionType,
}) => {
  const onButtonClicked = () => {
    if (MIXPANEL_ENABLED) {
      mixpanel.track('call_to_action', {
        product: displayName,
        id: solutionId,
        isEnhanced: true,
        solutionType,
      })
    }
  }
  return (
    <Link href={url} target="_blank">
      <button
        className={cn(styles.callAction, { 'min-w-[112px]  !bg-base': THEME === 'ilta' })}
        onClick={onButtonClicked}
      >
        {label}
      </button>
    </Link>
  )
}
